import React, {useEffect} from 'react';
import withRouter from './Components/withRouter';

//redux
import {useSelector} from "react-redux";
import Chat from '../Components/Chat';
import Header from "./Header";
import Footer from "./Footer";
import useAppLoadedHook from "../hooks/useAppLoadedHook";

const NonAuthLayout = ({children}) => {
    const isLoaded = useAppLoadedHook();

    const {
        layoutModeType,
    } = useSelector(state => ({
        layoutModeType: state.Layout.layoutModeType,
    }));

    useEffect(() => {
        if (layoutModeType === "dark") {
            document.body.setAttribute("data-layout-mode", "dark");
        } else {
            document.body.setAttribute("data-layout-mode", "light");
        }
        return () => {
            document.body.removeAttribute("data-layout-mode");
        };
    }, [layoutModeType]);

    return (
        <div>
            {!isLoaded && <div id="preloader" style={{opacity: 1, visibility: "visible"}}>
                <div id="status">
                    <div className="spinner-border text-primary avatar-sm" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>}
            <Header/>
            <div style={{minHeight: "calc(100vh - 335px)"}}>
                {children}
            </div>
            <Footer/>
            {/*chat on right*/}
            <Chat/>
        </div>
    );
};

export default withRouter(NonAuthLayout);